import { List } from "immutable"
import * as React from 'react'
import { async, AsyncState, fromJSX, IOWidget, loadingAsyncState, NavLink, Updater } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getOverview } from "../../../../drupal/api/api.mod"
import { PaginatedItem } from '../../../../drupal/types_and_parser/extra_types.mod'
import { ParsedMediaImage, ParsedNodeUpdate, ParsedParagraphCategory, ParsedParagraphGridBlocksImage } from '../../../../drupal/types_and_parser/types.ext.gen'
import { loader } from '../../../templates/loader.mod'
import { ensureSecureUrl, replace_cms_url } from '../../../utils/helpers'
import { getLangFromUrl } from '../../../utils/history.mod'


export type otherKeyProjectsBlockProps = {
  block_index: number
  field_extra_elements: ParsedParagraphCategory | ParsedParagraphGridBlocksImage
  updateNodes: AsyncState<PaginatedItem<ParsedNodeUpdate>>
}


export type otherKeyProjectsBlockStyle = {}

/**
 * NOTE: This block is called Extra navigational element in de CMS or extra_navigational_element
 * @param props
 * @param options
 */
export function otherKeyProjectsBlock(
  props: otherKeyProjectsBlockProps,
  options?: { style?: otherKeyProjectsBlockStyle; key?: string }
): (
    s: CMSState
  ) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((setState) => {

        const setBlockState = <K extends keyof otherKeyProjectsBlockProps>(prop: K, newValue: otherKeyProjectsBlockProps[K]) => (s: CMSState): CMSState => {
          if (!s.blocks.has(props.block_index)) return s
          let current_block = s.blocks.get(props.block_index)
          if (current_block.kind != 'otherKeyProjectsBlock') return s
          current_block = ({
            ...current_block,
            value: [
              {
                ...current_block.value[0],
                [prop]: newValue
              },
              current_block.value[1]
            ]
          })
          return ({ ...s, blocks: s.blocks.set(props.block_index, current_block) })
        }

        if (props.field_extra_elements.bundle == 'category' && props.updateNodes.kind == 'unloaded') {
          let label = props.field_extra_elements.field_category.id
          setState(setBlockState('updateNodes', loadingAsyncState(() => getOverview<ParsedNodeUpdate>('related-content-load-more', getLangFromUrl(), null, List([label]), true))))
        }



        return <>
          {async(props.updateNodes).run(a => setState(setBlockState('updateNodes', a(props.updateNodes))))}

          <section className="block block--others block-bg--grey ls-block-spacing">
            <div className="block__inner ls-container">
              {props.field_extra_elements.field_title &&
                <header className="block__header">
                  <h2 className="block__title title--l">{props.field_extra_elements.field_title}</h2>
              </header>
                }
              {/* {props.field_extra_elements.bundle == 'grid_blocks_image' && props.field_extra_elements.field_introduction && <p className='block__text'>{props.field_extra_elements.field_introduction}</p>} */}
              <div className='block__content'>
                <ul className='block__list grid'>
                  {
                    props.field_extra_elements.bundle == 'category' ?
                      props.updateNodes.kind == 'loaded' ?
                        props.updateNodes.value.items.filter(x => x != null).slice(0, 3).map(v => <OtherKeyProjectsItem CmsState={s} key={v.id} title={v.label} media={v.field_introduction_image} linkUrl={`/${v.language}${v.path}`} />)
                        : loader.run(_ => { })
                      : props.field_extra_elements.field_grid_blocks.map(v => <OtherKeyProjectsItem CmsState={s} key={v.id} title={v.field_title} linkUrl={v.field_link.url} media={v.field_image} />).toArray()
                  }
                </ul>
              </div>
            </div>
          </section>
        </>
      }
    )
}

interface OtherKeyProjectsItemProps {
  CmsState: CMSState
  media: ParsedMediaImage
  title: string
  linkUrl: string
}
const OtherKeyProjectsItem = (props: OtherKeyProjectsItemProps) => {
  return (
    <li className='grid__item'>
      <article className='grid__article'>
        <NavLink className="grid__link" to={`${props.linkUrl}`}>
          <div className='grid__content'>
            <header className="grid__header">
              <h3 className="grid__title title--s">{props.title}</h3>
            </header>
          </div>
          <div className='grid__visual fit-object'>
            <img
              loading="lazy"
              className='grid__image'
              src={replace_cms_url(ensureSecureUrl(props.media.field_media_image.image.style_urls['480x300']))}
              sizes="(min-width: 1800px) 480px, (min-width: 1024px) 30vw, (min-width: 768px) 50vw, 100vw"
              srcSet={[
                ['480w', replace_cms_url(ensureSecureUrl(props.media.field_media_image.image.style_urls['480x300']))],
                ['960w', replace_cms_url(ensureSecureUrl(props.media.field_media_image.image.style_urls['960x600']))],
                ['1440w', replace_cms_url(ensureSecureUrl(props.media.field_media_image.image.style_urls['1440x900']))]
              ].filter(([_, u]) => !!u)
                .reduce((acc, [s, u]) => {
                  const part = `${u} ${s}`
                  return acc == "" ? part : `${acc}, ${part}`
                }, "")}
              alt={props.media.field_media_image.alt}
              width="480"
              height="300"
            />
          </div>
        </NavLink>
      </article>
    </li>
  )
}

